import type { CorvidTypes } from '@wix/editor-elements-types/corvid';

export type IGalleryNavigationSDK = {
  next?: () => void;
  previous?: () => void;
  navigateNextEnabled: () => boolean;
  navigatePreviousEnabled: () => boolean;
  currentIndex: () => number;
  triggerItemClick: (e: Event, itemIndex: number) => void;
  navigateToIndex: (index: number, animationDuration: number) => void;
};

export const galleryNavigationSDKFactory: CorvidTypes.CorvidSDKFactory<
  IGalleryNavigationSDK
> = api => {
  const { compRef } = api;
  return {
    next() {
      compRef.next?.();
    },
    previous() {
      compRef.previous?.();
    },
    navigateNextEnabled() {
      return compRef.navigateNextEnabled?.();
    },

    navigatePreviousEnabled() {
      return compRef.navigatePreviousEnabled?.();
    },
    currentIndex() {
      return compRef.currentIndex?.();
    },
    triggerItemClick(e: Event, itemIndex: number) {
      compRef.triggerItemClick?.(e, itemIndex);
    },
    navigateToIndex(index: number, animationDuration: number) {
      compRef.navigateToIndex?.(index, animationDuration);
    },
  };
};
